import axios from "axios";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const GoogleCallback = () => {
  const location = useLocation();
  // const navigate = useNavigate();

  const fullPath = location.pathname + location.search;
  useEffect(() => {
    googleCallbackLogin();
  }, []);

  const googleCallbackLogin = () => {
    axios
      .get("/customer" + fullPath)
      .then((res) => {
        const token = res.data.data?.token;
        const userId = res.data.data?.userInformation?.id;
        const fullName = res.data.data?.userInformation?.full_name || "";
        const email = res.data.data?.userInformation?.email || "";
        const numberPhone = res.data.data?.userInformation?.phone_number || "";
        const avatarUrl = res.data.data?.userInformation?.avatar_url || "";
        const userAddresses = res.data.data?.userInformation?.addresses || [];

        localStorage.setItem("accessToken", token);
        localStorage.setItem("avatar_url", avatarUrl);
        localStorage.setItem("userId", userId);
        localStorage.setItem("fullName", fullName);
        localStorage.setItem("email", email);
        localStorage.setItem("numberPhone", numberPhone);

        localStorage.setItem("loginStatus", Date.now().toString());
        localStorage.setItem("userAddresses", JSON.stringify(userAddresses));
        window.close();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return <></>;
};
